import { Controller } from "@hotwired/stimulus"

// A <dialog> opened as a modal over the page. What it shows lives in a
// <template> (the `viewer` target) until the dialog opens and is dropped when
// it closes, so an embedded viewer starts visible and stops with the modal.
// `refresh` refills an open dialog after the template was redrawn.
export default class extends Controller {
  static targets = ["dialog", "viewer", "body"]

  open() {
    this.fill()
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  clear() {
    this.bodyTarget.replaceChildren()
  }

  refresh() {
    if (this.dialogTarget.open) this.fill()
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  fill() {
    this.bodyTarget.replaceChildren(this.viewerTarget.content.cloneNode(true))
  }
}
